import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/ui-components/Button';
import AddressBookGrid from '../AddressBookGrid';

const AddressBook = ({
  type,
  addresses,
  selectedAddress,
  setAddress,
  handleGuestBillingAddress,
  setAddressIsSelected,
}) => {
  const continueButton = useRef(null);

  const [addressBookAddresses, setAddressBookAddresses] = useState(addresses);
  const [addressBookAddress, setAddressBookAddress] = useState('');
  const [resetAddress, setResetAddress] = useState(false);

  const filterAddressesByValues = e => {
    const filterValue = e.target.value;
    const filterValueUpper = filterValue.toUpperCase();

    if (filterValue) {
      const filteredAddresses = addresses.filter(
        address =>
          address.postcode.toUpperCase().includes(filterValueUpper) ||
          address.line_1.toUpperCase().includes(filterValueUpper) ||
          address.name.toUpperCase().includes(filterValueUpper),
      );

      setAddressBookAddresses(filteredAddresses);
    } else {
      setAddressBookAddresses(addresses);
    }
  };

  const finaliseAddress = address => {
    if (handleGuestBillingAddress) {
      handleGuestBillingAddress(address);
    } else {
      setAddress(address);
    }

    if (setAddressIsSelected) {
      setAddressIsSelected(true);
    }
  };

  const resetSelectedAddress = () => {
    setResetAddress(true);
    setAddressBookAddress('');
  };

  const handleFilterInputTyping = e => {
    resetSelectedAddress();
    filterAddressesByValues(e);
    if (setAddressIsSelected) {
      setAddressIsSelected(false);
    }
  };

  return (
    <div className="checkout-sub-panel">
      <div className="fl-on fl-jc-sb">
        <h2>
          {type === 'payment'
            ? 'Select Billing Address'
            : 'Choose from your Address Book'}
        </h2>
      </div>

      <div className="fl-on fl-jc-sb">
        <div className="fl-fb-50">
          <input
            type="text"
            placeholder="Search Address Book by Postcode"
            onChange={handleFilterInputTyping}
            className="search-addresses"
            autoComplete="no"
          />
        </div>
      </div>

      <AddressBookGrid
        groupName="address-book"
        addressList={addressBookAddresses}
        selectedAddress={selectedAddress}
        setAddress={
          type === 'payment' ? finaliseAddress : setAddressBookAddress
        }
        scrollRef={continueButton}
        resetAddress={resetAddress}
        setResetAddress={setResetAddress}
      />

      {type === 'delivery' && (
        <span ref={continueButton}>
          <Button
            className="cef-btn cef-btn--green ff-body fw-600 mt-20 m-mt-28"
            handleClick={() => {
              finaliseAddress(addressBookAddress);
            }}
            disabled={addressBookAddress === ''}
            testId="continue-to-delivery-options">
            Continue to Delivery Options
          </Button>
        </span>
      )}
    </div>
  );
};

AddressBook.propTypes = {
  type: PropTypes.oneOf(['delivery', 'payment']).isRequired,
  addresses: PropTypes.array.isRequired,
  selectedAddress: PropTypes.object.isRequired,
  setAddress: PropTypes.func.isRequired,
  handleGuestBillingAddress: PropTypes.func,
  setAddressIsSelected: PropTypes.func,
};

export default AddressBook;
